<template>
  <div>
    <div v-if="item.commutingIncident">{{ $t("incidentReports.yes") }}</div>
    <div v-else>{{ $t("incidentReports.no") }}</div>
  </div>
</template>
<script>
export default {
  props: ["item"],
  methods: {},
};
</script>
